import "./paginator.scss"
import React from "react"
import { Button } from "react-bootstrap"

function Paginator({ offset, rowsDisplayed, totalRows, translationKeys, onNext, onPrevious }) {
  function isFirstPage() {
    return offset === 0
  }

  function isLastPage() {
    return totalRows - offset - rowsDisplayed <= 0
  }

  return (
    <div className="paginator">
      <Button className="pagination-button" variant="secondary" disabled={isFirstPage()} onClick={onPrevious}>
        <i className="fal fa-long-arrow-left" />
        {translationKeys?.previous}
      </Button>
      <Button className="pagination-button" variant="secondary" disabled={isLastPage()} onClick={onNext}>
        {translationKeys?.next}
        <i className="fal fa-long-arrow-right" />
      </Button>
    </div>
  )
}

export default Paginator
